import React, { Component } from 'react'
import { PopupboxManager, PopupboxContainer } from 'react-popupbox'
import { merge } from 'lodash'
import Highlight from 'react-highlight'

const cusConfig = {
  titleBar: {
    enable: true,
    text: 'Popupbox Demo'
  },
  fadeIn: {
    enable: true,
    speed: 500
  }
}

export default class Demo extends Component {
  onClickTrigger(bool) {
    const content = (
      <div>
        <p className="quotes">Work like you don't need the money.</p>
        <p className="quotes">Dance like no one is watching.</p>
        <p className="quotes">And love like you've never been hurt.</p>
        <span className="quotes-from">― Mark Twain</span>
      </div>
    )
    PopupboxManager.open({ content, config: bool ? cusConfig : null })
  }

  onClickDemo3() {
    const content = <img className="demoImg" src="cat.jpg" />
    PopupboxManager.open({
      content,
      config: merge({}, cusConfig, { titleBar: { text: 'Meow!' } })
    })
  }

  onClickDemo4() {
    const newContent = (
      <div>
        <span>Update popupbox with new content and config</span>
        <button className="demo-button" onClick={PopupboxManager.close}>Close</button>
      </div>
    )

    const updatePopupbox = () => {
      PopupboxManager.update({
        content: newContent,
        config: {
          titleBar: {
            text: 'Updated!'
          }
        }
      })
    }

    const content = (
      <div>
        <span>Open popupbox</span>
        <button className="demo-button" onClick={updatePopupbox}>Update!</button>
      </div>
    )

    PopupboxManager.open({
      content,
      config: merge({}, cusConfig, {
        titleBar: { text: 'Open popupbox' }
      })
    })
  }

  render() {
    return (
      <div className="demo">
        <PopupboxContainer />
        <div className="demo-default">
          <div className="demo-component">
            <span className="popupbox-trigger" onClick={this.onClickTrigger.bind(this, false)}>Click me</span>
          </div>
          <div className="demo-source">
            <Highlight language="javascript">
              {`
    import React, { Component } from 'react';
    import {
      PopupboxManager,
      PopupboxContainer
    } from 'react-popupbox';

    export class Example extends Component {
      openPopupbox() {
        const content = (
          <div>
            <p className="quotes">Work like you don't need the money.</p>
            <p className="quotes">Dance like no one is watching.</p>
            <p className="quotes">And love like you've never been hurt.</p>
            <span className="quotes-from">― Mark Twain</span>
          </div>
        )
        PopupboxManager.open({ content })
      }

      render() {
        return (
          <div>
            <button onClick={this.openPopupbox}>Click me</button>
            <PopupboxContainer />
          </div>
        )
      }
    }
              `}
            </Highlight>
          </div>
        </div>

        <div className="demo-trigger">
          <div className="demo-component">
            <p className="demo-componentDescribe">set default config ...</p>
            <a className="popupbox-trigger" onClick={this.onClickTrigger.bind(this, true)}>Click me</a>
          </div>
          <div className="demo-source">
            <Highlight language="javascript">
              {`
    render() {
      const popupboxConfig = {
        titleBar: {
          enable: true,
          text: 'Popupbox Demo'
        },
        fadeIn: true,
        fadeInSpeed: 500
      }

      render() {
        return (
          <div>
            <button onClick={this.openPopupbox}>Click me</button>
            <PopupboxContainer { ...popupboxConfig } />
          </div>
        )
      }
    }
              `}
            </Highlight>
          </div>
        </div>

        <div className="demo-config">
          <div className="demo-component">
            <p className="demo-componentDescribe">open popupbox with custom config ...</p>
            <span className="popupbox-trigger" onClick={this.onClickDemo3}>Click me</span>
          </div>
          <div className="demo-source">
            <Highlight className="jsx">
              {`
    openPopupbox() {
      const content = <img url="static/demo.jpg" />
      PopupboxManager.open({
        content,
        config: {
          titleBar: {
            enable: true,
            text: 'Meow!'
          },
          fadeIn: true,
          fadeInSpeed: 500
        }
      })
    }

    render() {
      return (
        <div>
          <button onClick={this.openPopupbox}>Click me</button>
          <PopupboxContainer />
        </div>
      )
    }
              `}
            </Highlight>
          </div>
        </div>


        <div className="demo-update">
          <div className="demo-component">
            <p className="demo-componentDescribe">update popupbox with new content or config ...</p>
            <span className="popupbox-trigger" onClick={this.onClickDemo4}>Click me</span>
          </div>
          <div className="demo-source">
            <Highlight language="javascript">
              {`
    updatePopupbox() {
      const content = (
        <div>
          <span>Update popupbox with new content and config</span>
          <button onClick={PopupboxManager.close}>Close</button>
        </div>
      )

      PopupboxManager.update({
        content,
        config: {
          titleBar: {
            text: 'Updated!'
          }
        }
      })
    }

    openPopupbox() {
      const content = (
        <div>
          <span>Open popupbox</span>
          <button onClick={this.updatePopupbox}>Update!</button>
        </div>
      )

      PopupboxManager.open({
        content,
        config: {
          titleBar: {
            enable: true,
            text: 'Step 1'
          },
          fadeIn: true,
          fadeInSpeed: 500
        }
      })
    }

    render() {
      return (
        <div>
          <button onClick={this.openPopupbox}>Click me</button>
          <PopupboxContainer />
        </div>
      )
    }
              `}
            </Highlight>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/demo.js